import React, { useCallback, useState } from 'react';

import { CODE_REQUIRED_OVERLAY } from 'config/constants';
import { clearBankrollCode } from 'reduxState/currentUserData/userBankroll';
import { staticDispatch } from 'reduxState/store';
import { useSelector } from 'reduxState/storeCore';

import BankrollAppliedModal from './BankrollAppliedModal';
import BankrollModal from './BankrollModal';
import WelcomePointsModal from './WelcomePointsModal';

export default function BankrollWorker() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const bankrollCodeToApply = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeToApply
  );
  const bankrollCodeToApplyType = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeType
  );
  const bankrollCodeApplied = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeApplied
  );
  const bankrollCodeAppliedMessage = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeAppliedMessage
  );
  const bankrollAddedInThisSession = useSelector(
    state => state.currentUserData.userBankroll.bankrollAddedInThisSession
  );

  const [closedPerWallet, setClosedPerWallet] = useState('-');

  const handleClose = useCallback(
    () => setClosedPerWallet(walletAddress),
    [walletAddress]
  );

  if (bankrollCodeApplied) {
    return (
      <BankrollAppliedModal
        bankrollCode={
          bankrollCodeToApplyType === 'welcomePoints'
            ? undefined
            : bankrollCodeApplied
        }
        message={bankrollCodeAppliedMessage}
        onClose={() => {
          staticDispatch(clearBankrollCode());
        }}
      />
    );
  }

  if (
    bankrollCodeToApplyType === 'welcomePoints' &&
    closedPerWallet !== walletAddress
    // (bankrollAddedInThisSession || walletAddress)
  ) {
    return (
      <WelcomePointsModal
        pointsBonusCode={bankrollCodeToApply}
        onClose={CODE_REQUIRED_OVERLAY ? undefined : handleClose}
      />
    );
  }

  if (
    bankrollCodeToApplyType === 'bankroll' &&
    bankrollCodeToApply &&
    closedPerWallet !== walletAddress &&
    (bankrollAddedInThisSession || walletAddress)
  ) {
    return (
      <BankrollModal bankrollCode={bankrollCodeToApply} onClose={handleClose} />
    );
  }

  return null;
}
